<template>
  <div class="audit-center-page">
    <van-nav-bar title="智慧体育助手 - 审核中心" fixed placeholder />

    <van-tabs v-model="activeTab" color="#1989fa" sticky offset-top="46px">
      
      <van-tab title="风云榜审核">
        <div class="tab-content">
          <div class="notice-bar">
            <van-icon name="fire-o" color="#ee0a24" />
            <span>待审核上榜记录，通过后将在全校“运动风云榜”展示。</span>
          </div>

          <div class="card-list" v-if="pendingAudits.length > 0">
            <div class="custom-card" v-for="item in pendingAudits" :key="item.id">
              <div class="card-header">
                <div>
                  <strong class="title-text">{{ item.studentName }}</strong>
                  <span class="sub-text">{{ item.className }}</span>
                </div>
                <van-tag type="warning">待审核</van-tag>
              </div>
              <div class="card-body">
                <div class="info-row"><span class="lbl">申请荣誉：</span><span class="val font-bold text-danger">{{ item.honorTitle }}</span></div>
                <div class="info-row"><span class="lbl">达成数据：</span><span class="val">{{ item.recordData }}</span></div>
                <div class="info-row"><span class="lbl">申请时间：</span><span class="val text-grey">{{ item.applyTime }}</span></div>
              </div>
              <div class="card-footer align-right">
                <van-button size="small" type="primary" round @click="handleAudit(item.id, 'pass')">审核通过</van-button>
                <van-button size="small" type="danger" plain round class="ml-sm" @click="handleAudit(item.id, 'reject')">驳回申请</van-button>
              </div>
            </div>
          </div>
          <van-empty v-else description="暂无待审核的风云榜记录" />
        </div>
      </van-tab>

      <van-tab title="学生管理">
        <div class="tab-content">
          <van-search v-model="studentKeyword" placeholder="输入学生姓名或学号搜索" @search="searchStudent" />
          
          <div class="card-list">
            <div class="custom-card" v-for="stu in filteredStudents" :key="stu.id">
              <div class="card-header">
                <div>
                  <strong class="title-text">{{ stu.name }}</strong>
                  <span class="sub-text">({{ stu.studentNo }})</span>
                </div>
                <van-tag :type="stu.status === '正常' ? 'success' : 'danger'" plain>{{ stu.status }}</van-tag>
              </div>
              <div class="card-body">
                <div class="info-row"><span class="lbl">行政班级：</span><span class="val">{{ stu.className }}</span></div>
                <div class="info-row"><span class="lbl">性别 / 身高 / 体重：</span><span class="val">{{ stu.gender }} / {{ stu.height }}cm / {{ stu.weight }}kg</span></div>
              </div>
              <div class="card-footer align-right">
                <van-button size="small" type="info" plain round @click="openEditStudent(stu)">编辑基础信息</van-button>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="权限分配">
        <div class="tab-content">
          <div class="notice-bar bg-blue">
            <van-icon name="manager-o" color="#1989fa" />
            <span>分配智慧体育助手子账号管理权限。</span>
          </div>

          <div class="card-list">
            <div class="custom-card" v-for="acc in accountList" :key="acc.id">
              <div class="card-header">
                <div>
                  <strong class="title-text">{{ acc.teacherName }}</strong>
                  <span class="sub-text">{{ acc.phone }}</span>
                </div>
                <van-tag :color="getRoleColor(acc.role)">{{ acc.role }}</van-tag>
              </div>
              <div class="card-body">
                <div class="info-row"><span class="lbl">负责模块：</span><span class="val">{{ acc.moduleDesc }}</span></div>
              </div>
              <div class="card-footer align-right">
                <van-button size="small" type="default" round @click="openRolePopup(acc)">调整账号权限</van-button>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

    </van-tabs>

    <van-dialog v-model="showStudentDialog" title="编辑学生基础信息" show-cancel-button @confirm="saveStudentInfo">
      <van-field v-model="editingStudent.name" label="姓名" placeholder="请输入姓名" />
      <van-field v-model="editingStudent.className" label="班级" placeholder="如：初一(1)班" />
      <van-field v-model="editingStudent.height" label="身高(cm)" type="number" placeholder="请输入身高" />
      <van-field v-model="editingStudent.weight" label="体重(kg)" type="number" placeholder="请输入体重" />
      <div style="padding: 10px 16px;">
        <span style="color: #646566; font-size: 14px; margin-right: 20px;">状态</span>
        <van-radio-group v-model="editingStudent.status" direction="horizontal" style="display: inline-flex;">
          <van-radio name="正常">正常</van-radio>
          <van-radio name="休学">休学</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>

    <van-action-sheet v-model="showRolePopup" title="分配账号权限">
      <div class="role-selector-content">
        <div style="margin-bottom: 16px; color: #969799; font-size: 14px;">
          正在为 <strong>{{ currentAccount.teacherName }}</strong> 分配系统权限：
        </div>
        <van-radio-group v-model="tempRole">
          <van-cell-group>
            <van-cell title="超级管理员" clickable @click="tempRole = '超级管理员'">
              <template #right-icon>
                <van-radio name="超级管理员" />
              </template>
            </van-cell>
            <van-cell title="体育组长/考官" clickable @click="tempRole = '体育组长/考官'">
              <template #right-icon>
                <van-radio name="体育组长/考官" />
              </template>
            </van-cell>
            <van-cell title="普通任课教师" clickable @click="tempRole = '普通任课教师'">
              <template #right-icon>
                <van-radio name="普通任课教师" />
              </template>
            </van-cell>
            <van-cell title="风云榜专职审核员" clickable @click="tempRole = '风云榜专职审核员'">
              <template #right-icon>
                <van-radio name="风云榜专职审核员" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-button type="info" block round style="margin-top: 20px;" @click="saveRoleChange">确认分配</van-button>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>
export default {
  name: 'AuditCenter',
  data() {
    return {
      activeTab: 0, // 默认风云榜审核

      // ================= 风云榜数据 =================
      pendingAudits: [
        { id: 101, studentName: '李强', className: '初三(2)班', honorTitle: '破校1000米跑记录', recordData: '2分58秒 (原记录3分04秒)', applyTime: '2026-04-12 10:30' },
        { id: 102, studentName: '王芳', className: '初一(4)班', honorTitle: '本月“耐力之星”', recordData: '累计跑步里程 45.5 km', applyTime: '2026-04-11 16:45' },
        { id: 103, studentName: '陈子涵', className: '初二(1)班', honorTitle: '引体向上满分达人', recordData: '连续完成 25 个', applyTime: '2026-04-10 09:15' }
      ],

      // ================= 学生管理数据 =================
      studentKeyword: '',
      studentList: [
        { id: 201, studentNo: '20230101', name: '张伟', className: '初一(1)班', gender: '男', height: '165', weight: '55', status: '正常' },
        { id: 202, studentNo: '20230102', name: '林晓', className: '初一(1)班', gender: '女', height: '158', weight: '48', status: '正常' },
        { id: 203, studentNo: '20220315', name: '赵铁柱', className: '初二(3)班', gender: '男', height: '172', weight: '65', status: '休学' },
      ],
      showStudentDialog: false,
      editingStudent: {}, // 正在编辑的学生对象副本

      // ================= 账号权限数据 =================
      accountList: [
        { id: 301, teacherName: '李建国', phone: '138****1234', role: '超级管理员', moduleDesc: '全系统功能配置与人员调配' },
        { id: 302, teacherName: '王海洋', phone: '139****5678', role: '体育组长/考官', moduleDesc: '体测发布、成绩核准、违规处理' },
        { id: 303, teacherName: '刘梅', phone: '137****9012', role: '风云榜专职审核员', moduleDesc: '风云榜记录初审与下发' },
      ],
      showRolePopup: false,
      currentAccount: {},
      tempRole: '', // 临时选中的角色
    };
  },
  computed: {
    // 搜索过滤学生列表
    filteredStudents() {
      if (!this.studentKeyword) return this.studentList;
      return this.studentList.filter(stu => 
        stu.name.includes(this.studentKeyword) || 
        stu.studentNo.includes(this.studentKeyword)
      );
    }
  },
  methods: {
    // ======== 风云榜审核 ========
    handleAudit(id, type) {
      const actionName = type === 'pass' ? '通过' : '驳回';
      this.$dialog.confirm({
        title: `确认${actionName}`,
        message: `确认要 ${actionName} 该学生的风云榜上榜申请吗？`
      }).then(() => {
        // 从列表中移除该条目（模拟已处理）
        this.pendingAudits = this.pendingAudits.filter(item => item.id !== id);
        this.$toast.success(`申请已${actionName}`);
      }).catch(() => {});
    },

    // ======== 学生信息管理 ========
    searchStudent() {
      this.$toast.loading({ duration: 500, forbidClick: true, message: '检索中...' });
    },
    openEditStudent(student) {
      // 深度拷贝，避免取消时修改了原数据
      this.editingStudent = JSON.parse(JSON.stringify(student));
      this.showStudentDialog = true;
    },
    saveStudentInfo() {
      // 找到原数组元素并替换更新
      const index = this.studentList.findIndex(s => s.id === this.editingStudent.id);
      if (index > -1) {
        this.$set(this.studentList, index, this.editingStudent);
        this.$toast.success('学生基础信息已更新');
      }
    },

    // ======== 权限分配管理 ========
    getRoleColor(role) {
      const colorMap = {
        '超级管理员': '#ee0a24',
        '体育组长/考官': '#ff976a',
        '风云榜专职审核员': '#07c160',
        '普通任课教师': '#1989fa'
      };
      return colorMap[role] || '#969799';
    },
    openRolePopup(account) {
      this.currentAccount = account;
      this.tempRole = account.role;
      this.showRolePopup = true;
    },
    saveRoleChange() {
      // 更新核心数据
      const target = this.accountList.find(a => a.id === this.currentAccount.id);
      if (target) {
        target.role = this.tempRole;
        // 模拟模块描述变化
        target.moduleDesc = this.tempRole === '超级管理员' ? '全系统功能配置与人员调配' : 
                            this.tempRole === '风云榜专职审核员' ? '风云榜记录初审与下发' : '负责日常教学班学生管理';
      }
      this.showRolePopup = false;
      this.$toast.success('权限分配成功！');
    }
  }
};
</script>

<style scoped>
.audit-center-page {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 30px;
}
.tab-content {
  padding: 12px;
}

/* 通知条样式 */
.notice-bar {
  background-color: #fff7cc;
  padding: 10px 12px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 12px;
  color: #ed6a0c;
}
.notice-bar span {
  margin-left: 6px;
}
.bg-blue {
  background-color: #f0f7ff;
  color: #1989fa;
}

/* 通用卡片样式 */
.custom-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f3f5;
  margin-bottom: 10px;
}
.title-text {
  font-size: 16px;
  color: #323233;
}
.sub-text {
  font-size: 13px;
  color: #969799;
  margin-left: 6px;
}

/* 卡片主体内容 */
.info-row {
  font-size: 13px;
  line-height: 1.8;
  display: flex;
}
.info-row .lbl {
  color: #969799;
  width: 75px;
  flex-shrink: 0;
}
.info-row .val {
  color: #323233;
  flex: 1;
}

/* 底部操作区 */
.card-footer {
  padding-top: 12px;
  margin-top: 8px;
  border-top: 1px dashed #ebedf0;
}
.align-right {
  text-align: right;
}

/* 权限弹窗内容 */
.role-selector-content {
  padding: 16px 16px 30px;
}

/* 辅助类 */
.ml-sm { margin-left: 8px; }
.font-bold { font-weight: bold; }
.text-danger { color: #ee0a24; }
.text-grey { color: #969799; }
</style>